import { createRouter, createWebHistory } from 'vue-router'

const BuyVignette = () =>
    import(/* webpackChunkName: 'buy-vignette' */ './components/BuyVignette/BuyVignette.vue')
const PaymentProcessing = () =>
    import(/* webpackChunkName: 'payment-processing' */ './components/PaymentProcessing.vue')

/** CMS pages are server-rendered HTML inside #app; there is no <router-view>. This route only satisfies Vue Router’s initial URL match so the console stays clean on non-SPA paths. */
const CmsPageShell = { name: 'CmsPageShell', render: () => null }

const routes = [
    {
        path: '/buy-vignette/:duration?',
        name: 'buy-vignette',
        component: BuyVignette,
    },
    {
        path: '/payment-processing',
        name: 'payment-processing',
        component: PaymentProcessing,
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'cms-page',
        component: CmsPageShell,
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router
